import { combineEpics } from "redux-observable";
import { epicDiscountEventActionButtonClick } from "./epics/epicDiscountEventActionButtonClick";
import { epicDiscountEventSelectEvent } from "./epics/epicDiscountEventSelectEvent";
import { epicDiscountEventShowMe } from "./epics/epicDiscountEventShowMe";
export var epicDiscountEvent = combineEpics(epicDiscountEventActionButtonClick, epicDiscountEventSelectEvent, epicDiscountEventShowMe);



//////////////////
// WEBPACK FOOTER
// ./src/features/discount-event/epicDiscountEvent.ts
// module id = 1830
// module chunks = 3